import YouTubePlayer from "youtube-player";
import { videoPlayed, videoPaused, videoEnded } from "../src/segment-tracks.js";

function createYTModal() {
  const ytModal = document.getElementById("youtube-modal");
  if (ytModal) return ytModal;

  // create a new div element if one doesn't exist
  const youtubeModal = document.createElement("div");
  youtubeModal?.setAttribute("id", "youtube-modal");
  youtubeModal?.classList.add(
    "bg-black",
    "fixed",
    "top-0",
    "h-full",
    "w-full",
    "p-gmd-base",
    "z-modal",
    "bg-opacity-75",
    "hidden",
    "flex",
    "items-center",
    "justify-center",
  );

  const buttonClose = document.createElement("div");
  buttonClose?.setAttribute("id", "btn-close-youtube-modal");
  buttonClose.classList.add(
    "bg-black",
    "bg-opacity-25",
    "text-white",
    "p-gut/2",
    "m-2gut",
    "fixed",
    "top-0",
    "right-0",
    "flex",
    "items-center",
    "justify-center",
  );
  buttonClose.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="w-gmd-md h-gmd-md"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';
  youtubeModal.append(buttonClose);

  document.body.appendChild(youtubeModal);
  return ytModal;
}

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
/**
 * Map *Event Data* to *State Names*
 * @type {Readonly<Object<string, string>>}
 */
const stateNames = {
  "-1": "unstarted",
  0: "ended",
  1: "playing",
  2: "paused",
  3: "buffering",
  5: "video cued",
};

/**
 * @param {HTMLElement} video
 * @param {number} idx
 */
function loadVideo(video, idx) {
  const videoId = /** @type {HTMLElement} */ (video)?.dataset["youtubeid"];
  const playerId = `${videoId}-${idx}`;
  const youtubeModal = createYTModal();

  const youtubePlayer = document.createElement("div");
  youtubePlayer?.setAttribute("id", "youtube-player-" + playerId);
  youtubePlayer.classList.add("hidden");
  youtubeModal?.appendChild(youtubePlayer);

  let player = YouTubePlayer("youtube-player-" + playerId, {
    height: "608",
    width: "1080",
  });

  player.on("stateChange", function (event) {
    const target = /** @type {any} */ (event.target);
    const video_current_time = Math.round(target.getCurrentTime()) || 0,
      video_duration = Math.round(target.getDuration()) || 0,
      video_percent =
        Math.round((video_current_time / video_duration) * 100) || 0,
      video_provider = "youtube",
      video_title = target.playerInfo.videoData.title || "NA",
      video_id = target.playerInfo.videoData.video_id || "NA",
      video_url = target.playerInfo.videoUrl || "NA";

    const options = {
      video_id: video_id,
      video_current_time: video_current_time,
      video_duration: video_duration,
      video_percent: video_percent,
      video_provider: video_provider,
      video_title: video_title,
      video_url: video_url,
    };

    if (!stateNames[event.data]) {
      throw new Error("Unknown state (" + event.data + ").");
    }

    if (stateNames[event.data] === "playing") {
      videoPlayed(options);
    }

    if (stateNames[event.data] === "paused") {
      videoPaused(options);
    }

    if (stateNames[event.data] === "ended") {
      videoEnded(options);
    }
  });

  player.on("ready", function () {
    video?.addEventListener("click", () => {
      openModal();
      document
        .getElementById("youtube-player-" + playerId)
        ?.classList.remove("hidden");
      player?.loadVideoById(/** @type {string} */ (videoId)).then(() => {
        player.playVideo();
      });
    });

    const btnClose = document.getElementById("btn-close-youtube-modal");
    btnClose?.addEventListener("click", () => {
      document
        .getElementById("youtube-player-" + playerId)
        ?.classList.add("hidden");
      player.pauseVideo();
      closeModal();
    });

    youtubeModal?.addEventListener("click", () => {
      document
        .getElementById("youtube-player-" + playerId)
        ?.classList.add("hidden");
      player.pauseVideo();
      closeModal();
    });
  });
}

function openModal() {
  document.getElementById("youtube-modal")?.classList.remove("hidden");
}

function closeModal() {
  document.getElementById("youtube-modal")?.classList.add("hidden");
}

// Get all youtube videos on the page
const youtubeVideos = document.querySelectorAll("[data-youtubeid]");

for (const [idx, video] of youtubeVideos.entries()) {
  if (video) {
    createYTModal();
    loadVideo(/** @type {HTMLElement} */ (video), idx);
  }
}
